var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93899 2.06543L5.28516 5.72935",
    stroke: "#9DB2CE",
    strokeWidth: 1.51402,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3789 2.06543L19.0327 5.72935",
    stroke: "#9DB2CE",
    strokeWidth: 1.51402,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06543 7.97084C2.06543 6.10355 3.06468 5.95215 4.30618 5.95215H20.0116C21.2531 5.95215 22.2523 6.10355 22.2523 7.97084C22.2523 10.1409 21.2531 9.98953 20.0116 9.98953H4.30618C3.06468 9.98953 2.06543 10.1409 2.06543 7.97084Z",
    stroke: "#9DB2CE",
    strokeWidth: 1.51402
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89795 14.1777V17.7609",
    stroke: "#9DB2CE",
    strokeWidth: 1.51402,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5415 14.1777V17.7609",
    stroke: "#9DB2CE",
    strokeWidth: 1.51402,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57959 10.1406L5.00277 18.8614C5.32576 20.8195 6.10295 22.2528 8.98968 22.2528H15.076C18.2151 22.2528 18.6794 20.8801 19.0428 18.9825L20.7385 10.1406",
    stroke: "#9DB2CE",
    strokeWidth: 1.51402,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.d68a939c04506b4ba41316be6d477812.svg";
export { ForwardRef as ReactComponent };